var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.title),expression:"title"}]},[_c('router-view'),_c('Popup'),_c('Question'),_c('Vote'),_c('UserName')],1)}
var staticRenderFns = []

export { render, staticRenderFns }